import { RouteConfig } from 'vue-router'
const route: RouteConfig[] = []
export default route
